// extracted by mini-css-extract-plugin
export default {"underline":"link_underline__-DFYN","clickableLink":"link_clickableLink__kC0wH","link":"link_link__zUrB8"};